<template>
    <v-dialog
        :hide-overlay="true"
        :persistent="true"
        v-model="alertModal"
        width="1000"
    >
        <v-card class="pt-0">
            <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
                style="background: rgb(26, 57, 88)"
            >
                <v-toolbar-title class="text-h6 white--text pl-0">
                    {{
                        (alertModalType
                            ? $t(
                                  "profile.alert." +
                                      capitalizeKey(alertModalType, "-", "")
                              )
                            : null) + $t("alertHub.alertDetailsTitle")
                    }}
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn color="white" icon @click="closeModal"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-app-bar>

            <v-card-actions>
                <v-row>
                    <template v-for="field in alertField[alertModalType]">
                        <v-col cols="2"
                            ><strong>{{ field.text }}</strong></v-col
                        >
                        <v-col cols="4">{{
                            ["action", "direction"].includes(field.key)
                                ? $t(
                                      `common.word.${alertDetail[
                                          field.key
                                      ].toLowerCase()}`
                                  )
                                : alertDetail[field.key]
                        }}</v-col>
                    </template>
                </v-row>
            </v-card-actions>

            <v-card-actions v-if="showTable">
                <v-data-table
                    dense
                    item-key="name"
                    :items="tableData"
                    :headers="tableHeader"
                    class="elevation-0 alert-datatable"
                    fixed-header
                    style="width: 100%"
                    :footer-props="{
                        'items-per-page-text': '',
                        'items-per-page-options': [10, 20],
                    }"
                >
                    <template v-slot:item.volume="{ item }">
                        {{ item.volume.toFixed(2) }}
                    </template>
                    <template v-slot:item.openTime="{ item }">
                        {{ toMT4Time(item.openTime) }}
                    </template>
                </v-data-table>
            </v-card-actions>

            <h3 style="margin-left: 16px; margin-top: 10px;" v-if="showChart">{{ alertDetail["chartName"] }}</h3>
            <v-card-actions v-if="showChart">
                <EChartDisplay
                    :chartData="alertDetail['chartData'] || {}"
                    :chartType="
                        alertDetail['chartData']['chart_type'] || 'line'
                    "
                    :chartHeight="300"
                    :chartName="alertDetail['chartName']"
                    :isOpen="alertModal"
                />
            </v-card-actions>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="closeModal">{{
                    $t("common.form.close")
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { helper } from "@components/mixins/helper";
import EChartDisplay from "@components/EChartDisplay.vue";

export default {
    components: { EChartDisplay },
    props: {
        alertModal: false,
        alertModalType: null,
        alertDetail: null,
        closeModal: Function,
    },
    mixins: [helper],
    data() {
        return {
            sortBy: undefined,
            sortDesc: undefined,
            offset: 30,
            currentPage: 1,
            alertInterval: null,
            isIBRequired: false,
            alertDataAmount: 0,
            alertData: [],
            loading: false,
            alertField: {
                "fast-trade": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "user",
                    },
                    {
                        text: "Book",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.symbol"),
                        key: "symbol",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.volume"),
                        key: "volume",
                    },
                    {
                        text: this.$t("common.table.direction"),
                        key: "direction",
                    },
                    {
                        text: this.$t("common.table.action"),
                        key: "action",
                    },
                    {
                        text: this.$t("common.table.timeThreshold"),
                        key: "thresholdTime",
                    },
                    {
                        text: this.$t("common.table.volumeThreshold"),
                        key: "thresholdVolume",
                    },
                ],
                "same-direction": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "login",
                    },
                    {
                        text: "Book",
                        key: "book",
                    },
                    {
                        text: this.$t("common.table.symbol"),
                        key: "symbol",
                    },
                    {
                        text: this.$t("common.table.totalVolume"),
                        key: "totalVolume",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.action"),
                        key: "action",
                    },
                ],
                "big-lot": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "login",
                    },
                    {
                        text: "Books",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.symbol"),
                        key: "symbol",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.volume"),
                        key: "volume",
                    },
                    {
                        text: this.$t("common.table.direction"),
                        key: "direction",
                    },
                    {
                        text: this.$t("common.table.action"),
                        key: "action",
                    },
                    {
                        text: this.$t("common.table.volumeThreshold"),
                        key: "thresholdVolume",
                    },
                ],
                "trade-on-credit": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "login",
                    },
                    {
                        text: "Books",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.equity"),
                        key: "equity",
                    },
                    {
                        text: this.$t("common.table.balance"),
                        key: "balance",
                    },
                    {
                        text: this.$t("common.table.credit"),
                        key: "credit",
                    },
                    {
                        text: this.$t(
                            "common.table.equityCreditRatioThreshold"
                        ),
                        key: "equityCreditRatioThreshold",
                    },
                ],
                "deposit-withdrawal": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "user",
                    },
                    {
                        text: "Book",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.action"),
                        key: "action",
                    },
                    {
                        text: this.$t("common.table.amount"),
                        key: "amount",
                    },
                    {
                        text: this.$t("common.table.withdrawDepositThreshold"),
                        key: "withdrawDepositThreshold",
                    },
                ],
                "large-volume-usd": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "user",
                    },
                    {
                        text: "Book",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.symbol"),
                        key: "symbol",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.volumeUSD"),
                        key: "volumeUSD",
                    },
                    {
                        text: this.$t("common.table.direction"),
                        key: "direction",
                    },
                    {
                        text: this.$t("common.table.action"),
                        key: "action",
                    },
                    {
                        text: this.$t("common.table.volumeThreshold"),
                        key: "largeVolumeUSDThreshold",
                    },
                ],
                "profit-taker": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "user",
                    },
                    {
                        text: "Book",
                        key: "books",
                    },
                    {
                        text: this.$t("common.table.symbol"),
                        key: "symbol",
                    },
                    {
                        text: this.$t("common.table.order"),
                        key: "order",
                    },
                    {
                        text: this.$t("common.table.volume"),
                        key: "volume",
                    },
                    {
                        text: this.$t("common.table.profitEOD"),
                        key: "profitClosedEod",
                    },
                    {
                        text: this.$t("common.table.profitThreshold"),
                        key: "profitThreshold",
                    },
                ],
                "time-decay": [
                    {
                        text: this.$t("common.table.server"),
                        key: "server_name",
                    },
                    {
                        text: this.$t("common.table.login"),
                        key: "login",
                    },
                    {
                        text: "Book",
                        key: "book",
                    },
                    {
                        text: this.$t("common.table.name"),
                        key: "name",
                    },
                    {
                        text: this.$t("common.table.dailyPnl"),
                        key: "daily_pnl",
                    },
                    {
                        text: this.$t("common.table.triggerTime"),
                        key: "trigger_time",
                    },
                ],
            },
            tableHeader: [
                {
                    text: this.$t("common.table.login"),
                    value: "login",
                    align: "left",
                },
                { text: "Book", value: "book", align: "left" },
                {
                    text: this.$t("common.table.volume"),
                    value: "volume",
                    align: "right",
                },
                {
                    text: this.$t("common.table.order"),
                    value: "orderID",
                    align: "left",
                },
                {
                    text: this.$t("common.table.openTime"),
                    value: "openTime",
                    align: "left",
                },
            ],
        };
    },
    computed: {
        showTable() {
            if (this.alertModalType === "same-direction") {
                return true;
            } else {
                return false;
            }
        },
        showChart() {
            if (this.alertModalType === "time-decay") {
                return true;
            } else {
                return false;
            }
        },
        tableData() {
            if (this.showTable) {
                return this.alertDetail?.["tableData"];
            } else {
                return undefined;
            }
        },
    },
};
</script>
